// v2017-11-27

import EzModal from "./_VueEzModal.vue";

export default {
  components: {
    EzModal
  },
  data() {
    return {
      showModal: false
    };
  }
};
